export const messengerConstants = {

    NEW_MESSAGE: 'NEW_MESSAGE',
    RESET_LIVE_MESSAGES_COUNT: 'RESET_LIVE_MESSAGES_COUNT',
    INCREMENT_TUTOR_MESSENGER_NOT_READ_COUNT: 'INCREMENT_TUTOR_MESSENGER_NOT_READ_COUNT',
    INCREMENT_STUDENT_MESSENGER_NOT_READ_COUNT: 'INCREMENT_STUDENT_MESSENGER_NOT_READ_COUNT',
    IN_CHAT_MESSENGER_NOT_READ_COUNT: "IN_CHAT_MESSENGER_NOT_READ_COUNT",
    IN_LIVE_MESSENGER_NOT_READ_COUNT: "IN_LIVE_MESSENGER_NOT_READ_COUNT",
}